import { render, staticRenderFns } from "./SubscriptionInfo.vue?vue&type=template&id=2d1bd284&scoped=true&"
import script from "./SubscriptionInfo.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionInfo.vue?vue&type=style&index=0&id=2d1bd284&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1bd284",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import GCardIcon from 'shared/global/components/CardIcon.vue'
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {GCardIcon,VCard,VCardTitle,VDataTable,VDivider})
